const Storage = (key) => ({
  get() {
    return JSON.parse(sessionStorage.getItem(key));
  },
  set(value) {
    const val = value !== null && typeof value === 'object' ? JSON.stringify(value) : value;
    sessionStorage.setItem(key, val);
  }
});

export default Storage;


/** WEBPACK FOOTER **
 ** ./src/sports/core/storage.js
 **/